import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import useApiConfiguration from '../../apiConfig';
import { GetReportLavoratoMensileRequest, LavoriApi } from '../../data/apis';
import Form, { FormRef, Item } from "devextreme-react/form";
import {Popup, Position, ToolbarItem} from "devextreme-react/popup";
import { useClienteDataSource } from "../../datasources/clienteDataSource";
import { useCommessaDataSource } from "../../datasources/commessaDataSource";
import { ClickEvent } from "devextreme/ui/button";
import { LoadPanel } from "devextreme-react";
import { useScreenSize } from "../../utils/media-query";

export type PopupAttivitaMensileHandle = {
    show: (idPersonale: number, data: Date) => void;
};

type State = {
    idPersonale: number,
    data: Date,
    visible: boolean
};

const PopupAttivitaMensile: React.ForwardRefRenderFunction<PopupAttivitaMensileHandle> = (props, ref) => {
    const emptyData: GetReportLavoratoMensileRequest = {
        idPersonale: undefined,
        idCliente: undefined,
        idCommessa: undefined,
        data: undefined
    };

    const apiConfiguration = useApiConfiguration();
    const formRef = useRef<FormRef>(null);

    const [loading, setLoading] = useState(false);
    const [state, setState] = useState<State>({ idPersonale: 0, data: undefined, visible: false });
    const [formData, setFormData] = useState<GetReportLavoratoMensileRequest>();
    const [clienteId, setClienteId] = useState<number | null>(null);
    const { isSmall, isXSmall } = useScreenSize();

    const clienteDataSource = useClienteDataSource(state.idPersonale);
    const commessaDataSource = useCommessaDataSource(state.idPersonale, state.data, clienteId);

    function hideInfo() {
        setState({ idPersonale: 0, data: undefined, visible: false });
    }

    useImperativeHandle(ref, () => ({
        show(idPersonale, data) {
            setState({ idPersonale: idPersonale, data: data, visible: true });
        }
    }));

    useEffect(() => {
        if (state.visible) {
            setFormData({
                ...emptyData,
                data: state.data,
                idPersonale: state.idPersonale
            });
        }
    }, [state.data, state.idPersonale, state.visible]);

    function riepilogoMensile(e: ClickEvent) {
        setLoading(true);
        var api = new LavoriApi(apiConfiguration);
        api.getReportLavoratoMensile({
            data: formData.data,
            idPersonale: formData.idPersonale,
            idCliente: formData.idCliente,
            idCommessa: formData.idCommessa   
        })
        .then((res) => {
            openPDF(res.base64);
        });
    }

    function openPDF(base64: string) {
        const byteChars = atob(base64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        
        setLoading(false);
        hideInfo();
    }

    const onFieldDataChanged = (e) => {
        const { dataField, value } = e;

        if (dataField === "idCliente" && value !== clienteId) {
            formData.idCommessa = null;
            setClienteId(value || null);
        }
    }

    return (
        <React.Fragment>
            <Popup
                visible={state.visible} dragEnabled={false} hideOnOutsideClick={true}
                showCloseButton={true} showTitle={true} title="Stampa attività mensile"
                fullScreen={(isSmall || isXSmall)} width={500} height={300}
                container=".dx-viewport" onHidden={hideInfo}
            >
                {
                    loading ? <LoadPanel style={{ zIndex: 9999 }} shading={true} shadingColor="rgba(0, 0, 0, 0.4)" position={'center'} visible={true} /> 
                    : (
                        <div>
                            <Position at="center" my="center" of="" collision="fit" />

                            <ToolbarItem
                                widget="dxButton" toolbar="bottom" location="center"
                                options={{
                                    text: "Anteprima",
                                    icon: "print",
                                    onClick: riepilogoMensile,
                                    visible: true
                                }}
                            />

                            <Form ref={formRef} labelMode="floating" colCount={1} 
                                formData={formData} onFieldDataChanged={onFieldDataChanged}
                            >
                                <Item visible={false} dataField="data" />
                                <Item visible={false} dataField="idPersonale" />

                                <Item label={{ text: "Cliente" }} editorType="dxSelectBox" dataField="idCliente"
                                    editorOptions={{
                                        dataSource: clienteDataSource,
                                        displayExpr: 'ragioneSociale',
                                        valueExpr: 'idCliente',
                                        searchEnabled: true,
                                        showClearButton: true
                                    }}
                                />

                                <Item label={{ text: "Commessa" }} editorType="dxLookup" dataField="idCommessa"
                                    editorOptions={{
                                        dataSource: commessaDataSource,
                                        disabled: !clienteId,
                                        displayExpr: 'descrizione',
                                        valueExpr: 'idCommessa',
                                        searchEnabled: true,
                                        showClearButton: true
                                    }}
                                />
                            </Form>
                        </div>
                    )
                }
            </Popup>
        </React.Fragment>
    )
}

export default React.forwardRef(PopupAttivitaMensile);